//wordpress dependencies
const { __ } = wp.i18n;
const { useState, useEffect, useRef, Component, createRef } = wp.element;
import { Spinner } from "@wordpress/components";
import axios from "axios";
import Qs from "qs";
import "./editor.scss";
import "./style.scss";
import Inspector from "./inspector";
import RenderView from "./renderView";
import classnames from "classnames";
import { CssGenerator } from "../../util/css/CssGenerator";

function Edit(props) {
	const { isSelected, attributes, setAttributes, className, clientId } = props;

	const { blockId } = attributes;
	const _client = clientId.substr(0, 6);
	useEffect(() => {
		if (!blockId) {
			setAttributes({ blockId: _client });
		} else if (blockId && blockId !== _client) {
			setAttributes({ blockId: _client });
		}
	}, []);

	if (blockId) {
		CssGenerator(attributes, 'listing-store', blockId);
	}

	const [storeFilter, setStoreFilter] = useState(false);
	const storeFilterChange = () => {
		setStoreFilter(!storeFilter);
	}

	const [data, setData] = useState([]);
	const [dataSuccess, setDataSuccess] = useState(true);
	useEffect(() => {
		let data = {
			action: 'rtcl_gb_store_list_block',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
			attributes: attributes
		}

		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {
				if (response.data.success) {
					setData([...response.data.data]);
					setDataSuccess(response.data.success)
				} else {
					setData([]);
					setDataSuccess(response.data.success)
				}
			})
			.catch((error) => console.log(error));

	}, [storeFilter]);

	const hasPosts = Array.isArray(data) && data.length;
	if (!hasPosts) {
		return [
			isSelected && (
				<Inspector
					attributes={attributes}
					setAttributes={setAttributes}
					storeFilterChange={storeFilterChange}
				/>
			),
			dataSuccess ? (<div className="rtcl-gb-spinner"><Spinner /></div>) : (
				__('No posts found.', 'classified-listing')
			)
		];
	}


	const MainWrapperClass = classnames([
		'rtcl-block-' + blockId,
		className,
		'rtcl-block-editor'
	]);

	//render
	return [
		isSelected && (
			<Inspector
				attributes={attributes}
				setAttributes={setAttributes}
				storeFilterChange={storeFilterChange}
			/>
		),

		<div className={MainWrapperClass}>
			<RenderView {...attributes} data={data} />
		</div>
	]
}

export default Edit;